import React from "react";
import RemoveButton from "../../../buttons/RemoveButton";
import styled from "styled-components";
import accountSVG from "../../../../images/account.svg";
import {getImage} from "../../../../utils/utils";

const MemberCard = ({
                        firstName,
                        lastName,
                        setId,
                        memberId,
                        picture,
                        setOpenDeleteModal,
                        isInteractive = true,
                    }) => {

    return (
        <Card onClick={isInteractive ? () => setId(memberId) : null}>
            <img
                src={getImage(picture, accountSVG)}
                alt="membre"
            />
            <p> {firstName === "Deleted" ? "Utilisateur supprimé" : firstName} {lastName === "User" ? "" : lastName} </p>
            {
                isInteractive &&
                <RemoveButton
                    setOpenModal={setOpenDeleteModal}
                />
            }
        </Card>
    )
}

const Card = styled.div`
  background-color: #FAFAFA;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.25);
  border-radius: 15px;
  align-items: center;
  justify-content: space-evenly;
  width: 100px;
  min-height: 120px;
  max-height: 120px;
  text-align: center;
  flex-direction: column;
  display: flex;
  padding: 0.5em;
  overflow: hidden;

  img {
    background: white;
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    object-fit: cover;
  }

  p {
    width: 100%;
    font-weight: 700;
    overflow: hidden;
    white-space: break-spaces;
    text-overflow: ellipsis;
  }

  button {
    position: relative;
    bottom: 100px;
    left: 35px;
    height: 0;
  }
`
export default MemberCard;